import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import FootballVidiprinter from 'modules/Football/components/FootballVidiprinter';
import {LocalFullDate} from 'modules/Common/components/LocalDateTime';

export default class FootballVidiprinterPage extends Component {
  static propTypes = {
    data: PropTypes.object
  };

  render() {
    require('./FootballVidiprinterPage.scss');
    const { data } = this.props;

    return (
      <div className="vidiprinter">
        <MetaDataWrapper title="Live Vidiprinter"/>
        <h1 className="vidiprinter-title">Live Vidiprinter</h1>
        <p className="vidiprinter-updated"><LocalFullDate/></p>
        <FootballVidiprinter data={data.items}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/components/FootballVidiprinterPage.js